import { InjectionToken } from "@angular/core";
import { CodeSolutionName } from "@Portal/Core/Solutions/CodeSolutionName";
import { InternalSolutionCode } from "@Portal/Core/Solutions/InternalSolutionCode";

export enum SolutionCode {
    BILLING = "Billing",
    BLOG = "Blog",
    COMMON = "Common",
    ELT = "Elt",
    FLEET = "Fleet",
    INTERSTATE = "Interstate",
    INSURANCE = "Insurance",
    LOGIN = "Login",
    RETAIL = "Retail",
    VITUSIGN = "VituSign",
}

export const SOLUTION = new InjectionToken<SolutionCode>("Solution");

export const SOLUTION_LIST = new InjectionToken<CodeSolutionName[]>("Solution list");

export function toInternalSolutionCode(code: SolutionCode) {

    const map = {
        [SolutionCode.COMMON]: null,
        [SolutionCode.LOGIN]: null,
        [SolutionCode.BILLING]: InternalSolutionCode.BILLING,
        [SolutionCode.BLOG]: InternalSolutionCode.BLOG,
        [SolutionCode.ELT]: InternalSolutionCode.ELT,
        [SolutionCode.FLEET]: InternalSolutionCode.FLEET,
        [SolutionCode.INTERSTATE]: InternalSolutionCode.INTERSTATE,
        [SolutionCode.INSURANCE]: InternalSolutionCode.INSURANCE,
        [SolutionCode.RETAIL]: InternalSolutionCode.RETAIL,
        [SolutionCode.VITUSIGN]: InternalSolutionCode.VITUSIGN,
    };

    return map[code];
}

export function pathnameToSolution(path: string) {

    if (path.toLowerCase().indexOf("/container") === 0) return SolutionCode.LOGIN;
    if (path.toLowerCase().indexOf("/billing") === 0) return SolutionCode.BILLING;
    if (path.toLowerCase().indexOf("/blog") === 0) return SolutionCode.BLOG;
    if (path.toLowerCase().indexOf("/elt") === 0) return SolutionCode.ELT;
    if (path.toLowerCase().indexOf("/fleet") === 0) return SolutionCode.FLEET;
    if (path.toLowerCase().indexOf("/insurance") === 0) return SolutionCode.INSURANCE;
    if (path.toLowerCase().indexOf("/interstate") === 0) return SolutionCode.INTERSTATE;
    if (path.toLowerCase().indexOf("/retail") === 0) return SolutionCode.RETAIL;
    if (path.toLowerCase().indexOf("/vitusign") === 0) return SolutionCode.VITUSIGN;
    return null;
}
